// Dark mode utility classes for consistent styling
export const darkModeClasses = {
  // Backgrounds
  bgPrimary: 'bg-white dark:bg-dark-bg-primary',
  bgSecondary: 'bg-white dark:bg-dark-bg-secondary', 
  bgTertiary: 'bg-gray-50 dark:bg-dark-bg-tertiary',
  
  // Text
  textPrimary: 'text-gray-900 dark:text-dark-text-primary',
  textSecondary: 'text-gray-600 dark:text-dark-text-secondary',
  textTertiary: 'text-gray-500 dark:text-dark-text-tertiary',
  
  // Borders
  borderPrimary: 'border-gray-200 dark:border-dark-border-primary',
  borderSecondary: 'border-gray-300 dark:border-dark-border-secondary',
  
  // Interactive
  hover: 'hover:bg-gray-50 dark:hover:bg-dark-bg-tertiary',
  
  // Common combinations
  card: 'bg-white dark:bg-dark-bg-secondary border dark:border-dark-border-primary',
  input: 'bg-white dark:bg-dark-bg-primary border-gray-300 dark:border-dark-border-primary text-gray-900 dark:text-dark-text-primary',
  container: 'bg-white dark:bg-dark-bg-secondary rounded-xl shadow-sm border dark:border-dark-border-primary',
  
  // Table classes
  tableHeader: 'bg-gray-50 dark:bg-dark-bg-secondary',
  tableRow: 'hover:bg-gray-50 dark:hover:bg-dark-bg-tertiary',
  
  // Status badges
  badgeGreen: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
  badgeBlue: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
  badgeRed: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
  badgePurple: 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300',
  badgeOrange: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300',
  badgeGray: 'bg-gray-100 dark:bg-gray-800/30 text-gray-800 dark:text-gray-300'
};

// Apply dark mode classes to common elements
export const applyDarkMode = (baseClasses: string, darkClasses: string) => {
  return `${baseClasses} ${darkClasses}`;
};

// Get report card classes based on color and active state
export const getReportCardClasses = (color: string, isActive: boolean) => {
  if (!isActive) {
    return 'border-gray-200 dark:border-dark-border-primary bg-gray-50 dark:bg-dark-bg-secondary';
  }
  
  const colorMap: Record<string, string> = {
    blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-300',
    green: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-300',
    red: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-300',
    purple: 'bg-purple-50 dark:bg-purple-900/20 border-purple-200 dark:border-purple-800 text-purple-800 dark:text-purple-300'
  };
  return colorMap[color] || colorMap.blue;
};

// Get info panel classes
export const getInfoPanelClasses = (color: string = 'blue') => {
  const colorMap: Record<string, string> = {
    blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-300',
    yellow: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-300',
    green: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-300',
    red: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-300'
  };
  return colorMap[color] || colorMap.blue;
};